<template>
  <w-icon-wrapper 
    icon-name='work-reset-icon'
    :width='27.077'
    :height='24.005'
    view-box='0 0 27.077 24.005'
  >
    <g 
      id="Gruppe_1" 
      data-name="Gruppe 1" 
      clip-path="url(#clip-path)"
    >
      <path 
        id="Pfad_1" 
        data-name="Pfad 1" 
        d="M21.469,1.847A12.011,12.011,0,0,0,4.035,7.26a11.856,11.856,0,0,0-.958,4.592l-1.37-1.37A1,1,0,0,0,.293,11.9L3.97,15.573,7.648,11.9a1,1,0,0,0-1.414-1.414L5.082,11.633a9.863,9.863,0,0,1,.79-3.582A10.126,10.126,0,0,1,6.6,6.661a10.008,10.008,0,1,1,3.13,13.8,1,1,0,1,0-1.066,1.691,12,12,0,0,0,18.108-12.8,11.929,11.929,0,0,0-5.307-7.5" 
        fill="currentColor"
      />
      <path 
        id="Pfad_2" 
        data-name="Pfad 2" 
        d="M19.658,7.288a1,1,0,0,0-1.414,0l-3.293,3.293L11.658,7.288A1,1,0,0,0,10.244,8.7l3.293,3.293-3.293,3.293A1,1,0,1,0,11.658,16.7l3.293-3.293L18.244,16.7a1,1,0,0,0,1.414-1.414l-3.293-3.293L19.658,8.7a1,1,0,0,0,0-1.414" 
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconReset' };
</script>
